import { useFormContext } from 'react-hook-form';
import { get } from 'lodash-es';

function useShouldDisable({ referenceFields, referenceValues, requireAll, referenceDisable }) {
    const { watch, selectedValues } = useFormContext();
    const fieldValues = watch([...(referenceFields ?? [])]);
    const selectValues = referenceValues?.map((value) => get(selectedValues[value.field], value.property)) ?? [];
    const allValues = [...(Array.isArray(fieldValues) ? fieldValues : []), ...selectValues].flat();

    const determineShouldDisable = (val, index, config) => {
        if (!!val && config[index] === '*') return true;
        if (Array.isArray(config[index])) {
            return config[index].includes(val?.value || val);
        }
        return (val?.value || val) === config[index];
    };

    let shouldDisable = false;

    if (referenceDisable) {
        if (requireAll) {
            shouldDisable = allValues.every((val, index) => determineShouldDisable(val, index, referenceDisable));
        } else {
            shouldDisable = allValues.some((val, index) => determineShouldDisable(val, index, referenceDisable));
        }
    }

    return shouldDisable;
}

export default useShouldDisable;
